"use strict";
// tslint:disable:deprecation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericFlyoutListMenuWidget = exports.FlyoutListMenuStyles = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TabStyles_1 = require("../styles/TabStyles");
var GlobalPointerDownOutsideListener_1 = require("../utils/GlobalPointerDownOutsideListener");
var Overlay_1 = require("../utils/Overlay");
var ListMenuWidget_1 = require("./ListMenuWidget");
var DefaultAnchorOrigin = {
    vertical: Overlay_1.VerticalOriginOption.bottom,
    horizontal: Overlay_1.HorizontalOriginOption.left
};
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Shadow = TabStyles_1.TabStyles.Shadow;
exports.FlyoutListMenuStyles = {
    backgroundColor: 'white',
    borderColor: Colors.L6,
    borderRadius: Sizing.BorderRadius,
    borderStyle: 'solid',
    borderWidth: Sizing.BorderWidth,
    boxShadow: Shadow.Standard
};
var GenericFlyoutListMenuWidget = /** @class */ (function (_super) {
    tslib_1.__extends(GenericFlyoutListMenuWidget, _super);
    function GenericFlyoutListMenuWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.unsubscribeFlyoutFromGlobalListener = null;
        _this.unsubscribeToggleElFromGlobalListener = null;
        _this.flyoutDomNode = null;
        _this.setFlyoutDomNode = function (ref) {
            _this.flyoutDomNode = ref;
        };
        _this.getAnchorClientRect = function () {
            if (_this.props.getAnchorClientRect) {
                return _this.props.getAnchorClientRect();
            }
            return _this.props.anchorEl ? _this.props.anchorEl.getBoundingClientRect() : undefined;
        };
        _this.handleKeyDown = function (e) {
            if (e.key === 'Tab') {
                e.stopPropagation();
                e.preventDefault();
                _this.props.requestCloseAll();
            }
        };
        return _this;
    }
    GenericFlyoutListMenuWidget.prototype.componentDidMount = function () {
        // Everything outside the toggling element/button or the flyout should trigger a close on mousedown
        if (this.flyoutDomNode) {
            this.unsubscribeFlyoutFromGlobalListener = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.flyoutDomNode, this.props.requestCloseAll);
        }
        if (this.props.toggleEl) {
            this.unsubscribeToggleElFromGlobalListener = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.props.toggleEl, this.props.requestCloseAll);
        }
    };
    GenericFlyoutListMenuWidget.prototype.componentWillUnmount = function () {
        var _a, _b, _c;
        (_a = this.unsubscribeFlyoutFromGlobalListener) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.unsubscribeToggleElFromGlobalListener) === null || _b === void 0 ? void 0 : _b.call(this);
        (_c = this.props.toggleEl) === null || _c === void 0 ? void 0 : _c.focus();
    };
    GenericFlyoutListMenuWidget.prototype.render = function () {
        // tslint:disable-next-line:max-line-length
        var _a = this.props, allowAutoPosition = _a.allowAutoPosition, anchorOrigin = _a.anchorOrigin, handleScrollOnScrollingRoot = _a.handleScrollOnScrollingRoot, menuStyle = _a.menuStyle, onMouseEnter = _a.onMouseEnter, scrollingRootId = _a.scrollingRootId, shouldAutoPositionOnScrollingRootScroll = _a.shouldAutoPositionOnScrollingRootScroll, stackedOrigin = _a.stackedOrigin, stackingRootId = _a.stackingRootId, zIndex = _a.zIndex, menuProps = tslib_1.__rest(_a, ["allowAutoPosition", "anchorOrigin", "handleScrollOnScrollingRoot", "menuStyle", "onMouseEnter", "scrollingRootId", "shouldAutoPositionOnScrollingRootScroll", "stackedOrigin", "stackingRootId", "zIndex"]);
        var overlayProps = {
            allowAutoPosition: allowAutoPosition,
            anchorOrigin: anchorOrigin,
            getAnchorClientRect: this.getAnchorClientRect,
            handleScrollOnScrollingRoot: handleScrollOnScrollingRoot,
            scrollingRootId: scrollingRootId,
            shouldAutoPositionOnScrollingRootScroll: shouldAutoPositionOnScrollingRootScroll,
            stackedOrigin: stackedOrigin,
            stackingRootId: stackingRootId,
            zIndex: zIndex,
        };
        var containerProps = {
            onKeyDown: this.handleKeyDown,
            onMouseEnter: onMouseEnter,
            ref: this.setFlyoutDomNode,
            style: tslib_1.__assign(tslib_1.__assign({}, exports.FlyoutListMenuStyles), menuStyle),
        };
        var listMenuProps = tslib_1.__assign(tslib_1.__assign({}, menuProps), { scrollingRootId: overlayProps.scrollingRootId, stackingRootId: overlayProps.stackingRootId, subMenuAllowAutoPosition: overlayProps.allowAutoPosition, subMenuShouldAutoPositionOnScrollingRootScroll: overlayProps.shouldAutoPositionOnScrollingRootScroll, zIndex: overlayProps.zIndex });
        return (React.createElement(Overlay_1.Overlay, tslib_1.__assign({}, overlayProps),
            React.createElement("div", tslib_1.__assign({}, containerProps),
                React.createElement(ListMenuWidget_1.ListMenuWidget, tslib_1.__assign({}, listMenuProps)))));
    };
    GenericFlyoutListMenuWidget.defaultProps = {
        anchorOrigin: DefaultAnchorOrigin,
        role: 'menu',
    };
    return GenericFlyoutListMenuWidget;
}(React.Component));
exports.GenericFlyoutListMenuWidget = GenericFlyoutListMenuWidget;
//# sourceMappingURL=FlyoutListMenuWidget.js.map